var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mt-10" }, [
    _c(
      "div",
      { staticClass: "bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6" },
      [
        _c("div", { staticClass: "md:grid md:grid-cols-3 md:gap-6" }, [
          _c("div", { staticClass: "md:col-span-1" }, [
            _c(
              "h3",
              { staticClass: "text-lg font-medium leading-6 text-gray-900" },
              [_vm._v(" Share widget ")]
            ),
            _c(
              "div",
              [_c("WhatsappShareButton", { attrs: { config: _vm.config } })],
              1
            )
          ]),
          _c("div", { staticClass: "mt-5 md:mt-0 md:col-span-2" }, [
            _c("form", { on: { submit: _vm.handleSubmit } }, [
              _c("fieldset", { staticClass: "mt-6" }, [
                _c(
                  "legend",
                  {
                    staticClass: "text-base leading-6 font-medium text-gray-900"
                  },
                  [_vm._v(" Position ")]
                ),
                _c(
                  "div",
                  { staticClass: "mt-4 flex flex-wrap" },
                  _vm._l(_vm.supportedPosition, function(position, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "flex items-center m-2" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.config.shareButton.position,
                              expression: "config.shareButton.position"
                            }
                          ],
                          staticClass:
                            "form-radio h-4 w-4 text-indigo-600 transition duration-150 ease-in-out",
                          attrs: {
                            id: "radio_share_" + position.value,
                            type: "radio"
                          },
                          domProps: {
                            value: position.value,
                            checked: _vm._q(
                              _vm.config.shareButton.position,
                              position.value
                            )
                          },
                          on: {
                            change: function($event) {
                              return _vm.$set(
                                _vm.config.shareButton,
                                "position",
                                position.value
                              )
                            }
                          }
                        }),
                        _c(
                          "label",
                          {
                            staticClass: "ml-3",
                            attrs: { for: "radio_share_" + position.value }
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "block text-sm leading-5 font-medium text-gray-700"
                              },
                              [_vm._v(_vm._s(position.label) + " ")]
                            )
                          ]
                        )
                      ]
                    )
                  }),
                  0
                )
              ]),
              _c("fieldset", { staticClass: "mt-6" }, [
                _c(
                  "legend",
                  {
                    staticClass: "text-base leading-6 font-medium text-gray-900"
                  },
                  [_vm._v(" Design ")]
                ),
                _c(
                  "div",
                  { staticClass: "mt-4 flex flex-wrap" },
                  _vm._l(_vm.supportedDesign, function(design, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "flex items-center m-2" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.config.shareButton.design,
                              expression: "config.shareButton.design"
                            }
                          ],
                          staticClass:
                            "form-radio h-4 w-4 text-indigo-600 transition duration-150 ease-in-out",
                          attrs: {
                            id: "radio_share_design_" + design.value,
                            type: "radio"
                          },
                          domProps: {
                            value: design.value,
                            checked: _vm._q(
                              _vm.config.shareButton.design,
                              design.value
                            )
                          },
                          on: {
                            change: function($event) {
                              return _vm.$set(
                                _vm.config.shareButton,
                                "design",
                                design.value
                              )
                            }
                          }
                        }),
                        _c(
                          "label",
                          {
                            staticClass: "ml-3",
                            attrs: { for: "radio_share_design_" + design.value }
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "block text-sm leading-5 font-medium text-gray-700"
                              },
                              [_vm._v(_vm._s(design.label) + " ")]
                            )
                          ]
                        )
                      ]
                    )
                  }),
                  0
                )
              ]),
              _c("div", { staticClass: "mt-6" }, [
                _c("div", { staticClass: "rounded-md " }, [
                  _c("div", { staticClass: "grid grid-cols-6 gap-6" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-span-6 sm:col-span-6 lg:col-span-2 relative"
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass:
                              "block text-sm font-medium leading-5 text-gray-700",
                            attrs: { for: "city" }
                          },
                          [_vm._v("Button Background ")]
                        ),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value:
                                _vm.config.shareButton.colors
                                  .buttonBackgroundColor,
                              expression:
                                "config.shareButton.colors.buttonBackgroundColor"
                            }
                          ],
                          staticClass:
                            "mt-1 form-input block w-full py-2 px-12 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5",
                          domProps: {
                            value:
                              _vm.config.shareButton.colors
                                .buttonBackgroundColor
                          },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.config.shareButton.colors,
                                "buttonBackgroundColor",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _c("verte", {
                          staticClass: "colorPicker",
                          attrs: { picker: "square", model: "hex" },
                          model: {
                            value:
                              _vm.config.shareButton.colors
                                .buttonBackgroundColor,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.config.shareButton.colors,
                                "buttonBackgroundColor",
                                $$v
                              )
                            },
                            expression:
                              "config.shareButton.colors.buttonBackgroundColor"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-span-6 sm:col-span-6 lg:col-span-2 relative"
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass:
                              "block text-sm font-medium leading-5 text-gray-700",
                            attrs: { for: "city" }
                          },
                          [_vm._v("Button Text Color")]
                        ),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value:
                                _vm.config.shareButton.colors.buttonTextColor,
                              expression:
                                "config.shareButton.colors.buttonTextColor"
                            }
                          ],
                          staticClass:
                            "mt-1 form-input block w-full py-2 px-12 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5",
                          domProps: {
                            value: _vm.config.shareButton.colors.buttonTextColor
                          },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.config.shareButton.colors,
                                "buttonTextColor",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _c("verte", {
                          staticClass: "colorPicker",
                          attrs: { picker: "square", model: "hex" },
                          model: {
                            value:
                              _vm.config.shareButton.colors.buttonTextColor,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.config.shareButton.colors,
                                "buttonTextColor",
                                $$v
                              )
                            },
                            expression:
                              "config.shareButton.colors.buttonTextColor"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-span-6 sm:col-span-6 lg:col-span-2 relative"
                      },
                      [
                        _c(
                          "label",
                          {
                            staticClass:
                              "block text-sm font-medium leading-5 text-gray-700",
                            attrs: { for: "city" }
                          },
                          [_vm._v("Button Icon Color")]
                        ),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value:
                                _vm.config.shareButton.colors.buttonIconColor,
                              expression:
                                "config.shareButton.colors.buttonIconColor"
                            }
                          ],
                          staticClass:
                            "mt-1 form-input block w-full py-2 px-12 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5",
                          domProps: {
                            value: _vm.config.shareButton.colors.buttonIconColor
                          },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.config.shareButton.colors,
                                "buttonIconColor",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _c("verte", {
                          staticClass: "colorPicker",
                          attrs: { picker: "square", model: "hex" },
                          model: {
                            value:
                              _vm.config.shareButton.colors.buttonIconColor,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.config.shareButton.colors,
                                "buttonIconColor",
                                $$v
                              )
                            },
                            expression:
                              "config.shareButton.colors.buttonIconColor"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]),
                _c("div", { staticClass: "mt-6" }, [
                  _c("div", { staticClass: "rounded-md shadow-sm" }, [
                    _c("div", { staticClass: "grid grid-cols-6 gap-6" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-span-6 sm:col-span-6 lg:col-span-2 relative"
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass:
                                "block text-sm font-medium leading-5 text-gray-700",
                              attrs: { for: "city" }
                            },
                            [_vm._v("Button Label")]
                          ),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.config.shareButton.label,
                                expression: "config.shareButton.label"
                              }
                            ],
                            staticClass:
                              "mt-1 form-input block w-full py-2 px-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5",
                            domProps: { value: _vm.config.shareButton.label },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.config.shareButton,
                                  "label",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]
                      )
                    ])
                  ])
                ]),
                _c(
                  "div",
                  { staticClass: "mt-8 border-t border-gray-200 pt-5" },
                  [
                    _c("div", { staticClass: "flex justify-end" }, [
                      _c(
                        "span",
                        {
                          staticClass: "ml-3 inline-flex rounded-md shadow-sm"
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass:
                                "Polaris-Button Polaris-Button--primary",
                              attrs: { type: "submit" },
                              on: {
                                click: function($event) {
                                  return _vm.$emit("save")
                                }
                              }
                            },
                            [_vm._m(0)]
                          )
                        ]
                      )
                    ])
                  ]
                )
              ])
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "Polaris-Button__Content" }, [
      _c("span", { staticClass: "Polaris-Button__Text" }, [_vm._v("Save")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }